// @flow

export default {
  latest: ['last 1 safari major version'],
  maintenance: ['last 2 safari major versions'],
  next: ['unreleased safari versions', 'last 1 safari major version'],
};
